<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="8">
        <autocomplete
          :label="$t('choose_language')"
          v-model="settings.language"
          :items="languageOptions"
          hide-details
          multiple
          item-value="code"
          item-text="name"
        />
      </v-col>
      <v-col cols="12" md="4">
        <p class="text-caption mb-1">{{ $t("enter_language") }}</p>
        <v-radio-group @change="changeLang" v-model="model" row>
          <v-radio :label="latLabel" value="lat"></v-radio>
          <v-radio label="Ћир" value="cir"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import restaurantService from "@/services/restaurant";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasModel from "@/mixins/hasModel";

export default {
  name: "LanguageSettingsSection",
  mixins: [hasModel, hasSnackbar],
  props: {
    settings: {
      type: Object,
      required: true,
    },
    restaurantId: {
      type: [String, Number],
      required: true,
    },
    translate: {
      type: Function,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      hrv: "",
    };
  },
  computed: {
    languageOptions() {
      return [
        { code: "sr", name: "Српски - ћирилица" },
        { code: "sr-lat", name: "Srpski - Latinica" },
        { code: "rs", name: "Ћирилица" },
        { code: "rs-lat", name: "Latinica" },
        { code: "hr", name: "Hrvatski" },
        { code: "bs", name: "Bosanski" },
        { code: "en", name: "English" },
        { code: "mk", name: "Makedonski" },
        { code: "si", name: "Slovenščina" },
        { code: "ru", name: "Русский (Ruski)" },
        { code: "es", name: "Español (Španski)" },
        { code: "it", name: "Italiano (Italijanski)" },
        { code: "fr", name: "Français (Francuski)" },
        { code: "de", name: "Deutsch (Nemački)" },
        { code: "zh", name: "中文 (Kineski)" },
        { code: "tr", name: "Türkçe (Turski)" },
        { code: "uz", name: "Oʻzbekcha (Uzbečki)" },
      ];
    },
    latLabel() {
      return this.translate ? this.translate(this.$t("lat")) : this.$t("lat");
    },
  },
  methods: {
    async changeLang(alphabet) {
      const lat = alphabet === "lat";
      const cir = alphabet === "cir";

      try {
        const res = await restaurantService.updateRestaurantTextLanguage(
          this.restaurantId,
          {
            lat: lat,
            cir: cir,
            hrv: this.hrv,
            alphabet: alphabet,
          }
        );
        this.$root.$emit("langChanged", res);
        this.showSuccessSnackbar(this.$t("alphabet_updated_successfully"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_alphabet"));
      }
      this.$forceUpdate();
    },
  },
};
</script>
